import React from 'react'
import a1 from '../img/a1.jpeg'
import a2 from '../img/a2.jpeg'
import a3 from '../img/a3.jpeg'
import a4 from '../img/a4.jpeg'
import a5 from '../img/a5.jpeg'
import a6 from '../img/a6.jpeg'
import a7 from '../img/a7.jpeg'
import a8 from '../img/a8.jpeg'
import a9 from '../img/a9.jpeg'
import a10 from '../img/a10.jpeg'
import a11 from '../img/a11.jpeg'
import a12 from '../img/a12.jpeg'
import a13 from '../img/a13.jpeg'
import a14 from '../img/a14.jpeg'
import a15 from '../img/a15.jpeg'
import a16 from '../img/a16.jpeg'

const Gallary = () => {
    return (
        <>
          <div className="gallary">
              <div className="gallary__wrapper"></div>
                 <div className="gallary__content">
                        <h1># Fest <span>Gallery</span></h1>
                        <div className="imgs_container">
                               <img src={a1} alt="" />
                               <img src={a2} alt="" />
                               <img src={a3} alt="" />
                               <img src={a4} alt="" />
                               <img src={a5} alt="" />
                               <img src={a6} alt="" />
                               <img src={a7} alt="" />
                               <img src={a8} alt="" />
                               <img src={a9} alt="" />
                               <img src={a10} alt="" />
                               <img src={a11} alt="" />
                               <img src={a12} alt="" />
                               <img src={a13} alt="" />
                               <img src={a14} alt="" />
                               <img src={a15} alt="" />
                               <img src={a16} alt="" />
                              
                        </div>
                 </div>
              </div>  
        </>
    )
}

export default Gallary
